import { render, staticRenderFns } from "./ResultGame.vue?vue&type=template&id=073fb842&"
import script from "./ResultGame.vue?vue&type=script&lang=js&"
export * from "./ResultGame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports